import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import EN from './locales/en';
import RU from './locales/ru';
import KZ from './locales/kz';

const SUPPORTED_LANGS = ['ru', 'en', 'kz'];

function normalizeLang(raw) {
  if (!raw) return null;
  const value = String(raw).toLowerCase();
  const base = value.split(/[-_]/)[0];
  return SUPPORTED_LANGS.includes(base) ? base : null;
}

function getInitialLanguage() {
  // Priority: URL (?lang=) -> localStorage -> browser language -> fallback
  if (typeof window !== 'undefined') {
    try {
      const urlLang = new URLSearchParams(window.location.search).get('lang');
      const normalizedUrl = normalizeLang(urlLang);
      if (normalizedUrl) return normalizedUrl;
    } catch (_) {
      // ignore
    }

    try {
      const stored =
        window.localStorage?.getItem('lang') ||
        window.localStorage?.getItem('i18nextLng');
      const normalizedStored = normalizeLang(stored);
      if (normalizedStored) return normalizedStored;
    } catch (_) {
      // ignore
    }

    const navLang =
      normalizeLang(window.navigator?.language) ||
      normalizeLang(window.navigator?.languages?.[0]);
    if (navLang) return navLang;
  }

  return 'ru';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        basic: EN,
      },
      ru: {
        basic: RU,
      },
      kz: {
        basic: KZ,
      },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false, 
    },
  });

export default i18n;